const isLoggedIn = () => {
  return true;
};

export default isLoggedIn;
